module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-BOOSTER-GREEN-1.70773583.jpg";